module.exports = __webpack_public_path__ + "img/avatar.c0920045.png";